import { createSlice } from "@reduxjs/toolkit";
import { t } from "@lingui/core/macro";
import {
  setLoadingState,
  setSuccessState,
  setFailureState,
  initialApiState,
} from "@Src/redux/utils/apiHelpers";

export const initialState = {
  favoritesList: {
    api: initialApiState,
    stores: [],
  },
  favoritedStores: {
    api: initialApiState,
    stores: [],
  },
  callbackMessage: null,
};

const favoritesSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    fetchFavorites(state) {
      setLoadingState(state.favoritesList.api);
    },
    fetchFavoritesSuccess(state, action) {
      setSuccessState(state.favoritesList.api);
      state.favoritesList.stores = action.payload.favorites;
    },
    fetchFavoritesFailure(state, action) {
      setFailureState(state.favoritesList.api, action.payload.error);
    },
    addFavorite(state) {
      setLoadingState(state.favoritesList.api);
    },
    addFavoriteSuccess(state, action) {
      setSuccessState(state.favoritesList.api, t`Successfully added favorite.`);
      state.favoritesList.stores = action.payload.favorites;
    },
    addFavoriteFailure(state, action) {
      setFailureState(state.favoritesList.api, action.payload.error);
    },
    removeFavorite(state) {
      setLoadingState(state.favoritesList.api);
    },
    removeFavoriteSuccess(state, action) {
      setSuccessState(state.favoritesList.api, t`Successfully removed favorite.`);
      state.favoritesList.stores = action.payload.favorites;
    },
    removeFavoriteFailure(state, action) {
      setFailureState(state.favoritesList.api, action.payload.error);
    },
    signOutSuccess() {
      return initialState;
    },
    fetchFavoritedStores(state) {
      setLoadingState(state.favoritedStores.api);
    },
    fetchFavoritedStoresSuccess(state, action) {
      setSuccessState(state.favoritedStores.api);
      state.favoritedStores.stores = action.payload.stores;
    },
    fetchFavoritedStoresFailure(state, action) {
      setFailureState(state.favoritedStores.api, action.payload.error);
    },
    removeFavoritedStore(state, action) {
      const brandId = action.payload.brandId;
      state.favoritedStores.stores = state.favoritedStores.stores.filter(
        (item) => item.store_key !== brandId,
      );
    },
  },
});

export const actions = favoritesSlice.actions;

export default favoritesSlice.reducer;
